import React, { useEffect, useState } from 'react';
import {
  Dimensions,
  Platform,
  Pressable,
  StyleSheet,
  Text,
  View,
  TextInput,
  FlatList,
  TouchableOpacity,
  ScrollView,
  Modal,
} from 'react-native';
import { Picker } from '@react-native-picker/picker';
import axios from 'axios';
import { Formik } from 'formik';
import * as yup from 'yup';

import { BASE_URL } from '../../../components/BaseUrl';
import LeftBar from '../../../shared/LeftBar';
import LeftBarItem from '../../../shared/LeftBarItem';
import ErrorText from '../../../shared/errorText';
import { globalStyles } from '../../../styles/globalStyles';
import SearchForm from './../../../components/BookmarkList/SearchForm';
import LeftBarItemAdmin from '../../../shared/LeftBarItemAdmin';
import {
  DefaultThemeColors,
  DarkThemeColors,
  ThemeOne,
  ThemeTwo,
} from '../../../utils/constants/Colors';
import { useRoute } from '@react-navigation/native';
import { adminMenus } from '../../../shared/adminMenus';
const Colors2 = ThemeOne;

const windowWidth = Dimensions.get('window').width;

const basicInfoSchema = yup.object({
  division_name: yup.string().required('Division is required'),
  district_name: yup.string().required('District is required'),
  building_name_id: yup.string().required('Adalot is required'),
  lower_court_name: yup.string().required('Lower Court is required'),
});
const basicInfoSearchSchema = yup.object({
  division_name: yup.string().required('Division is required'),
  district_name: yup.string().required('District is required'),
  sBuilding_name_id: yup.string().required('District is required'),
});

export const OfflineAdalotComponent = () => {
  const [division, setDivision] = useState([]);
  const [district, setDistrict] = useState([]);
  const [lowerCourt, setLowerCourt] = useState([]);

  const [division_id, setDivisionId] = useState('');
  const [district_id, setDistrictId] = useState('');
  const [districtName, setDistrictName] = useState('');
  const [searchDivision_id, setSearchDivisionId] = useState('');
  const [searchDistrict_id, setSearchDistrictId] = useState('');
  const [searchTypeOfAdalotId, setSearchTypeOfAdalotId] = useState('');
  const [searchDivisionName, setSearchDivisionName] = useState('');
  const [searchDistrict_name, setSearchDistrictName] = useState('');
  const [thana_id, setThanaId] = useState('');
  const [lower_court_id, setLowerCourtId] = useState('');
  const [selectedLowerCourt, setSelectedLowerCourt] = useState(null);
  const [allData, setAllData] = useState([]);
  const [typeOfAalto_id, setTypeOfAaltoId] = useState(null);
  const [courtTypes, setCourtTypes] = useState([]);
  // State for edit modal
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editDivisionId, setEditDivisionId] = useState('');
  const [editDistrictId, setEditDistrictId] = useState('');
  const [editLowerCourtName, setEditLowerCourtName] = useState('');
  const [editDistrictData, setEditDistrictData] = useState([]);
  const [editBuildingNameId, setEditBuildingNameId] = useState('');
  const route = useRoute();
  useEffect(() => {
    fetchDivisionData();
  }, []);
  const typeOfAalto = [
    {
      id: '2',
      name: 'জেলা জজ আদালত',
      office_origin_ids: [
        4, 5, 6, 7, 8, 18, 19, 20, 21, 74, 75, 76, 83, 94, 103, 105,
      ],
      type: '1',
    },
    {
      id: '3',
      name: 'চীফ জুডিসিয়াল ম্যাজিস্ট্রেট আদালত',
      office_origin_ids: [14, 15, 16, 17, 84, 85, 91, 95],
      type: '1',
    },
    {
      id: '4',
      name: 'ট্রাইবুনালসমূহ',
      office_origin_ids: [
        89, 9, 72, 73, 77, 79, 80, 81, 82, 86, 87, 96, 102, 104, 110, 111, 112,
      ],
      type: '1',
    },
  ];
  const METRO_DISTRICT_IDS = [65, 66, 67, 68, 69, 70];
  const COURT_TYPE_METRO = [
    { id: '5', name: 'মহানগর দায়রা জজ আদালত', officeOriginIds: [10, 11, 12, 88], type: '2' },
    {
      id: '6',
      name: 'চীফ মেট্রোপলিটন ম্যাজিস্ট্রেট আদালত',
      officeOriginIds: [13, 22, 23, 24, 78, 92, 100],
      type: '2',
    },
    { id: '7', name: 'বিশেষ ট্রাইব্যুনাল', officeOriginIds: [109], type: '2' },
  ];
  const updateDivision = (handleChange, value) => {
    handleChange(value);
  };

  const updateDistrict = (handleChange, e) => {
    handleChange(e);
  };
  const fetchDivisionData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/GetDivission`);
      setDivision(res.data || []);
    } catch (error) {
      console.log('Division Error:', error);
    }
  };

  const fetchDistrictData = async divisionId => {
    try {
      const formBody = `division_id=${encodeURIComponent(divisionId)}`;

      const res = await axios.post(`${BASE_URL}/DivisionToDistrict`, formBody, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      setDistrict(res.data || []);
      setDistrictId('');
      setThanaId('');
      setLowerCourtId('');
      setLowerCourt([]);
      setSelectedLowerCourt(null);
    } catch (error) {
      console.log('District Error:', error);
    }
  };

  const fetchEditDistrictData = async divisionId => {
    try {
      const formBody = `division_id=${encodeURIComponent(divisionId)}`;

      const res = await axios.post(`${BASE_URL}/DivisionToDistrict`, formBody, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      setEditDistrictData(res.data || []);
    } catch (error) {
      console.log('District Error:', error);
    }
  };

  const fetchLowerCourtData = async districtId => {
    try {
      const formBody = `geo_district_id=${encodeURIComponent(
        districtId,
      )}&geo_division_id=${encodeURIComponent(division_id)}`;

      const res = await axios.post(
        `${BASE_URL}/DivisionAndDistrictToCourtName`,
        formBody,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        },
      );

      setLowerCourt(res.data || []);
      setThanaId('');
      setLowerCourtId('');
      setSelectedLowerCourt(null);
    } catch (error) {
      console.log('Lower Court Error:', error);
    }
  };



  const handleSearch = async () => {
    if (!searchDivision_id || !searchDistrict_id) {
      alert('Please select both division and district to search');
      return;
    }

    // console.log("Please select", {
    //   geo_division_id: searchDivision_id,
    //   geo_district_id: searchDistrict_id,
    //   building_name_id: searchTypeOfAdalotId,
    //   status: 1,
    // })
    try {
      const res = await axios.get(
        `${BASE_URL}/GetOfflineLowerCourtByDivisionAndDistrict`,
        {
          params: {
            geo_division_id: searchDivision_id,
            geo_district_id: searchDistrict_id,
            building_name_id: searchTypeOfAdalotId,
            status: 1,
          },
        }
      );
      console.log('Search Response:', res);
      if (res.status == 200) {
        setAllData(res.data);
      }
    } catch (error) {
      console.log('Get All Data Error:', error);
    }
  };

  const handleSubmitForm = async () => {
    const payload = {
      geo_division_id: division_id,
      geo_district_id: district_id,
      office_name_bng: lower_court_id || '',
      building_name_id: typeOfAalto_id,
      status: 1,
    };
    if (
      !payload.office_name_bng ||
      !payload.geo_division_id ||
      !payload.geo_district_id ||
      !payload.building_name_id
    ) {
      console.log('No lower court selected');
      return;
    }

    let formBody = [];
    for (let key in payload) {
      let encodedKey = encodeURIComponent(key);
      let encodedValue = encodeURIComponent(payload[key]);
      formBody.push(encodedKey + '=' + encodedValue);
    }

    formBody = formBody.join('&');
    let url = `${BASE_URL}/OfflineLowerCourtSave`;

    try {
      let response = await axios.post(url, formBody);
      alert('Data added successfully');
      handleGetAllData();

      // Reset form fields
      setDivisionId('');
      setDistrictId('');
      setLowerCourtId('');
    } catch (error) {
      console.log('Submit Error:', error?.response?.data || error.message);
      alert('Error adding data');
    }
  };

  const handleUpdateStatus = async item => {
    const updatedStatus = item.status === 1 ? 0 : 1;
    try {
      let url = `${BASE_URL}/OfflineLowerCourtToggleStatus/?status=${updatedStatus}&id=${item.id}`;
      let response = await axios.post(url);
      alert('Status updated successfully');
      handleGetAllData()
    } catch (error) {
      console.log('Update Error:', error);
      alert('Error updating status');
    }
  };



  const handleGetAllData = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/GetOfflineLowerCourtByDivisionAndDistrict`,
      );
      if (res.status == 200) {
        setAllData(res.data);
      }
    } catch (error) {
      console.log('Get All Data Error:', error);
    }
  };
  const handleEditData = async item => {
    setIsEditModalVisible(true);
    setEditId(item.id);
    setEditDivisionId(item.geo_division_id?.toString());
    setEditDistrictId(item.geo_district_id?.toString());
    setEditBuildingNameId(item.building_name_id?.toString()); // Add this line
    setEditLowerCourtName(item.office_name_bng?.toString());

    // Fetch districts for the selected division
    await fetchEditDistrictData(item.geo_division_id?.toString());
  };

  const handleUpdateData = async () => {
    if (!editLowerCourtName || !editDivisionId || !editDistrictId || !editBuildingNameId) {
      alert('Please fill all fields');
      return;
    }

    const payload = {
      id: editId,
      office_name_bng: editLowerCourtName || '',
      geo_division_id: editDivisionId,
      geo_district_id: editDistrictId,
      building_name_id: editBuildingNameId, // Add this field
      status: 1,
    };

    let formBody = [];
    for (let key in payload) {
      let encodedKey = encodeURIComponent(key);
      let encodedValue = encodeURIComponent(payload[key]);
      formBody.push(encodedKey + '=' + encodedValue);
    }

    formBody = formBody.join('&');

    try {
      // Fix the API endpoint - use the correct one for updating offline lower court
      let url = `${BASE_URL}/OfflineLowerCourtUpdate`; // Changed from GrbranchUpdate
      let response = await axios.post(url, formBody);
      alert('Data updated successfully');
      setIsEditModalVisible(false);
      handleGetAllData();

      // Reset edit states
      setEditId(null);
      setEditDivisionId('');
      setEditDistrictId('');
      setEditBuildingNameId(''); // Reset this too
      setEditLowerCourtName('');
      setEditDistrictData([]);
    } catch (error) {
      console.log('Update Error:', error);
      alert('Error updating data');
    }
  };

  const renderItem = ({ item, index }) => {
    return (
      <View style={styles.card}>
        <Text style={styles.serial}>{index + 1}.</Text>

        <View style={[styles.content]}>
          <Text style={styles.name}>{item.office_name_bng}</Text>
          <TouchableOpacity onPress={() => handleUpdateStatus(item)}>
            <Text
              style={[
                styles.status,
                {
                  color: item.status === 1 ? '#16a34a' : '#dc2626',
                },
              ]}
            >
              {item.status === 1 ? 'Active' : 'Inactive'}
            </Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={() => handleEditData(item)}>
            <Text
              style={[
                styles.status,
                {
                  color: '#f5a905',
                },
              ]}
            >
              Edit
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    );
  };

  return (
    <ScrollView>
      <View
        style={
          Platform.OS === 'web' && windowWidth >= 600
            ? globalStyles.mainContainerAdmin
            : globalStyles.mainContainerMobile
        }
      >
        <LeftBar>
          {adminMenus.map((item, index) => (
            <LeftBarItemAdmin
              key={item.screen || index}
              activeScreen={route.name}
              name={item.name}
              stack={item.stack}
              screen={item.screen}
            />
          ))}

        </LeftBar>

        <View
          style={
            Platform.OS === 'web' && windowWidth >= 600
              ? globalStyles.bodyContainer
              : globalStyles.bodyContainerMobile
          }
        >
          <View style={styles.headerContainer}>
            <Text style={styles.headerTexth}> অফলাইন আদালত যুক্ত করুন </Text>
          </View>
          <Formik
            initialValues={{
              division_name: '',
              district_name: '',
              lower_court_name: '',
              building_name_id: '',
            }}
            validationSchema={basicInfoSchema}
            onSubmit={handleSubmitForm}
          >
            {({
              handleChange,
              handleSubmit,
              setFieldTouched,
              setFieldValue,
              touched,
              errors,
            }) => (
              <>
                <View style={styles.formWrapper}>
                  {/* Division */}
                  <View style={styles.FormGroup}>
                    <View style={styles.pickerWrapper}>
                      <Picker
                        selectedValue={division_id || ''}
                        style={styles.picker}
                        onValueChange={itemValue => {
                          setDivisionId(itemValue);
                          fetchDistrictData(itemValue);
                          handleChange('division_name')(itemValue);
                          setFieldTouched('division_name', true);
                        }}
                        mode="dropdown"
                      >
                        <Picker.Item
                          label="বিভাগ নির্বাচন করুনঃ–"
                          value=""
                          color="red"
                        />
                        {division.map((item, index) => (
                          <Picker.Item
                            key={index}
                            label={item.division_name_bng?.toString()}
                            value={item.geo_division_id?.toString()}
                          />
                        ))}
                      </Picker>
                    </View>
                    {touched.division_name && errors.division_name ? (
                      <ErrorText>{errors.division_name}</ErrorText>
                    ) : null}
                  </View>

                  {/* District */}
                  <View style={styles.FormGroup}>
                    <View style={styles.pickerWrapper}>
                      <Picker
                        selectedValue={district_id || ''}
                        style={styles.picker}
                        onValueChange={(itemValue, idx) => {
                          setDistrictId(itemValue);
                          setFieldTouched('district_name', true);
                          setFieldValue('district_name', itemValue, true);
                          fetchLowerCourtData(itemValue);
                          handleChange('district_name')(itemValue);

                          setCourtTypes(
                            METRO_DISTRICT_IDS.includes(Number(itemValue))
                              ? COURT_TYPE_METRO
                              : typeOfAalto,
                          );
                        }}
                        mode="dropdown"
                      >
                        <Picker.Item
                          label="জেলা নির্বাচন করুনঃ–"
                          value=""
                          color="red"
                        />
                        {district.map((item, index) => (
                          <Picker.Item
                            key={index}
                            label={item.district_name_bng?.toString()}
                            value={item.geo_district_id?.toString()}
                          />
                        ))}
                      </Picker>
                    </View>
                    {touched.district_name && errors.district_name ? (
                      <ErrorText>{errors.district_name}</ErrorText>
                    ) : null}
                  </View>

                  {/* type of adalot */}
                  <View style={styles.FormGroup}>
                    <View style={[styles.pickerWrapper]}>
                      <Picker
                        selectedValue={
                          typeOfAalto_id ? typeOfAalto_id : '0'
                        }
                        style={styles.picker}
                        dropdownIconColor="#1e3a8a"
                        onValueChange={(itemValue, itemIndex) => {
                          setTypeOfAaltoId(itemValue);
                          setFieldTouched('building_name_id', true);
                          setFieldValue('building_name_id', itemValue, true);
                          handleChange('building_name_id')(itemValue);
                        }}
                        mode="dropdown"
                      >
                        <Picker.Item
                          label="আদালতের ধরন"
                          value="0"
                          color="red"
                        />

                        {courtTypes.map((item, index) => (
                          <Picker.Item
                            key={index}
                            label={`- ${item.name}`}
                            value={item.id.toString()}
                            color="#333"
                          />
                        ))}
                      </Picker>

                      {touched.building_name_id && errors.building_name_id ? (
                        <ErrorText>{errors.building_name_id}</ErrorText>
                      ) : null}
                    </View>
                  </View>
                  {/* Lower Court Input */}
                  <View style={styles.FormGroup}>
                    <View style={styles.inputWrapper}>
                      <TextInput
                        placeholder="অধস্তন আদালত লিখুন"
                        placeholderTextColor="#999"
                        style={styles.textInput}
                        value={lower_court_id}
                        onChangeText={text => {
                          setLowerCourtId(text);
                          setFieldTouched('lower_court_name', true);
                          setFieldValue('lower_court_name', text, true);
                          handleChange('lower_court_name')(text);
                        }}
                      />
                    </View>
                    {touched.lower_court_name && errors.lower_court_name ? (
                      <ErrorText>{errors.lower_court_name}</ErrorText>
                    ) : null}
                  </View>

                  <Pressable style={styles.submitButton} onPress={handleSubmit}>
                    <Text style={styles.submitButtonText}>Add</Text>
                  </Pressable>
                </View>
              </>
            )}
          </Formik>

          <View style={styles.wrapper}>
            <Formik
              initialValues={{
                division_name: '',
                district_name: '',
                sBuilding_name_id: '',
              }}
              validationSchema={basicInfoSearchSchema}
              onSubmit={handleSearch}
            >
              {({
                handleChange,
                handleSubmit,
                setFieldTouched,
                setFieldValue,
                touched,
                errors,
              }) => (
                <>
                  <View
                    style={[
                      styles.formWrapper,
                      {
                        paddingVertical: 0,
                        paddingHorizontal: 0,
                        borderRadius: 0,
                        borderWidth: 'none',
                      },
                    ]}
                  >
                    {/* Division */}
                    <View style={styles.FormGroup}>
                      <View style={styles.pickerWrapper}>
                        <Picker
                          selectedValue={searchDivision_id || ''}
                          style={styles.picker}
                          onValueChange={itemValue => {
                            setSearchDivisionId(itemValue);
                            fetchDistrictData(itemValue);
                            setFieldTouched('division_name', true);
                            setFieldValue('division_name', itemValue, true);
                            handleChange('division_name')(itemValue);
                          }}
                          mode="dropdown"
                        >
                          <Picker.Item
                            label="বিভাগ নির্বাচন করুনঃ–"
                            value=""
                            color="red"
                          />
                          {division.map((item, index) => (
                            <Picker.Item
                              key={index}
                              label={item.division_name_bng?.toString()}
                              value={item.geo_division_id?.toString()}
                            />
                          ))}
                        </Picker>
                      </View>
                      {touched.division_name &&
                        errors.division_name &&
                        !searchDivision_id ? (
                        <ErrorText>{errors.division_name}</ErrorText>
                      ) : null}
                    </View>

                    {/* District */}
                    <View style={styles.FormGroup}>
                      <View style={styles.pickerWrapper}>
                        <Picker
                          selectedValue={searchDistrict_id || ''}
                          style={styles.picker}
                          onValueChange={(itemValue, idx) => {
                            setSearchDistrictId(itemValue);
                            fetchLowerCourtData(itemValue);
                            setFieldTouched('district_name', true);
                            setFieldValue('district_name', itemValue, true);
                            handleChange('district_name')(itemValue);
                            setDistrictName(
                              district[idx - 1]?.district_name_bng,
                            );
                            setCourtTypes(
                              METRO_DISTRICT_IDS.includes(Number(itemValue))
                                ? COURT_TYPE_METRO
                                : typeOfAalto,
                            );
                          }}
                          mode="dropdown"
                        >
                          <Picker.Item
                            label="জেলা নির্বাচন করুনঃ–"
                            value=""
                            color="red"
                          />
                          {district.map((item, index) => (
                            <Picker.Item
                              key={index}
                              label={item.district_name_bng?.toString()}
                              value={item.geo_district_id?.toString()}
                            />
                          ))}
                        </Picker>
                      </View>
                      {touched.district_name &&
                        errors.district_name &&
                        !searchDistrict_id ? (
                        <ErrorText>{errors.district_name}</ErrorText>
                      ) : null}
                    </View>
                    <View style={styles.FormGroup}>
                      <View style={styles.pickerWrapper}>
                        <Picker
                          selectedValue={searchTypeOfAdalotId || ''}
                          style={styles.picker}
                          onValueChange={itemValue => {
                            setSearchTypeOfAdalotId(itemValue);
                            setFieldTouched('sBuilding_name_id', true);
                            setFieldValue('sBuilding_name_id', itemValue, true);
                            handleChange('sBuilding_name_id')(itemValue);

                          }}
                          mode="dropdown"
                        >
                          <Picker.Item
                            label="আদালতের ধরন"
                            value="0"
                            color="red"
                          />

                          {courtTypes.map((item, index) => (
                            <Picker.Item
                              key={index}
                              label={`- ${item.name}`}
                              value={item.id.toString()}
                              color="#333"
                            />
                          ))}
                        </Picker>
                      </View>
                      {touched.sBuilding_name_id &&
                        errors.sBuilding_name_id &&
                        !searchDistrict_id ? (
                        <ErrorText>{errors.sBuilding_name_id}</ErrorText>
                      ) : null}
                    </View>
                    <Pressable
                      style={styles.submitButton}
                      onPress={handleSearch}
                    >
                      <Text style={styles.submitButtonText}>Search</Text>
                    </Pressable>
                  </View>
                </>
              )}
            </Formik>

            <FlatList
              data={allData}
              keyExtractor={item => item.id.toString()}
              renderItem={renderItem}
              showsVerticalScrollIndicator={true}
              scrollEnabled={true}
            />
          </View>
        </View>
      </View>

      {/* Edit Modal */}
      <Modal
        animationType="slide"
        transparent={true}
        visible={isEditModalVisible}
        onRequestClose={() => setIsEditModalVisible(false)}
      >
        <View style={styles.modalOverlay}>
          <View style={styles.modalContainer}>
            <Text style={styles.modalTitle}>Edit Data</Text>

            {/* Division Picker */}
            <View style={styles.modalFormGroup}>
              <Text style={styles.modalLabel}>Division</Text>
              <View style={styles.modalPickerWrapper}>
                <Picker
                  selectedValue={editDivisionId || ''}
                  style={styles.modalPicker}
                  onValueChange={async itemValue => {
                    setEditDivisionId(itemValue);
                    await fetchEditDistrictData(itemValue);
                    setEditDistrictId('');
                  }}
                  mode="dropdown"
                >
                  <Picker.Item
                    label="বিভাগ নির্বাচন করুনঃ–"
                    value=""
                    color="red"
                  />
                  {division.map((item, index) => (
                    <Picker.Item
                      key={index}
                      label={item.division_name_bng?.toString()}
                      value={item.geo_division_id?.toString()}
                    />
                  ))}
                </Picker>
              </View>
            </View>

            {/* District Picker */}
            <View style={styles.modalFormGroup}>
              <Text style={styles.modalLabel}>District</Text>
              <View style={styles.modalPickerWrapper}>
                <Picker
                  selectedValue={editDistrictId || ''}
                  style={styles.modalPicker}
                  onValueChange={itemValue => {
                    setEditDistrictId(itemValue);
                  }}
                  mode="dropdown"
                >
                  <Picker.Item
                    label="জেলা নির্বাচন করুনঃ–"
                    value=""
                    color="red"
                  />
                  {editDistrictData.map((item, index) => (
                    <Picker.Item
                      key={index}
                      label={item.district_name_bng?.toString()}
                      value={item.geo_district_id?.toString()}
                    />
                  ))}
                </Picker>
              </View>
            </View>

            {/* Type of Adalot */}
            <View style={styles.modalFormGroup}>
              <Text style={styles.modalLabel}>Adalot Type</Text>
              <View style={styles.modalPickerWrapper}>
                <Picker
                  selectedValue={editBuildingNameId || ''}
                  style={styles.modalPicker}
                  onValueChange={itemValue => {
                    setEditBuildingNameId(itemValue);
                  }}
                  mode="dropdown"
                >
                  <Picker.Item
                    label="আদালতের ধরন নির্বাচন করুন"
                    value=""
                    color="red"
                  />
                  {courtTypes.map((item, index) => (
                    <Picker.Item
                      key={index}
                      label={`- ${item.name}`}
                      value={item.id.toString()}
                      color="#333"
                    />
                  ))}
                </Picker>
              </View>
            </View>

            {/* Lower Court Input */}
            <View style={styles.modalFormGroup}>
              <Text style={styles.modalLabel}>Lower Court Name</Text>
              <View style={styles.modalInputWrapper}>
                <TextInput
                  placeholder="অধস্তন আদালত লিখুন"
                  placeholderTextColor="#999"
                  style={styles.modalTextInput}
                  value={editLowerCourtName}
                  onChangeText={setEditLowerCourtName}
                />
              </View>
            </View>

            {/* Modal Buttons */}
            <View style={styles.modalButtonContainer}>
              <TouchableOpacity
                style={[styles.modalButton, styles.cancelButton]}
                onPress={() => setIsEditModalVisible(false)}
              >
                <Text style={styles.cancelButtonText}>Cancel</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[styles.modalButton, styles.updateButton]}
                onPress={handleUpdateData}
              >
                <Text style={styles.updateButtonText}>Update</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  headerContainer: {
    marginTop: 15,
    marginHorizontal: 10,
  },
  headerTexth: {
    fontSize: 20,
    fontWeight: 'bold',
    color: Colors2.top5,
    textAlign: 'left',
    marginLeft: 10,
  },
  formWrapper: {
    width: '96%',
    marginLeft: '2%',
    marginTop: 12,
    marginBottom: 12,
    paddingVertical: 24,
    paddingHorizontal: 20,
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    backgroundColor: '#ffffff',
    borderRadius: 18,
    borderWidth: 1,
    borderColor: '#e8eefc',
    shadowColor: '#0f172a',
    shadowOffset: { width: 0, height: 10 },
    shadowOpacity: 0.08,
    shadowRadius: 20,
    elevation: 8,
  },
  FormGroup: {
    marginBottom: 14,
    marginHorizontal: 8,
  },
  pickerWrapper: {
    borderWidth: 1,
    borderColor: '#000',
    borderRadius: 4,
    backgroundColor: '#fff',
    overflow: 'hidden',
    height: Platform.OS === 'web' && windowWidth >= 600 ? 30 : 30,
  },
  picker: {
    height: Platform.OS === 'web' && windowWidth >= 600 ? 42 : 50,
    width: '100%',
    color: '#333',
  },
  picker2: {
    height: Platform.OS === 'web' && windowWidth >= 600 ? 42 : 50,
    width: '100%',
    color: '#333',
  },
  submitButton: {
    backgroundColor: '#007bff',
    paddingVertical: 5,
    paddingHorizontal: 24,
    borderRadius: 4,
    alignSelf: 'flex-start',
    marginLeft: '2%',
  },
  submitButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
  },
  inputWrapper: {
    borderWidth: 2,
    borderColor: '#000',
    borderRadius: 4,
    backgroundColor: '#fff',
    height: 30,
    justifyContent: 'center',
    paddingHorizontal: 0,
  },
  textInput: {
    width: '100%',
    height: 40,
    color: '#333',
    fontSize: 14,
    paddingHorizontal: 8,
  },
  wrapper: {
    width: '96%',
    marginLeft: '2%',
    marginTop: 24,
    marginBottom: 20,
    paddingVertical: 20,
    paddingHorizontal: 16,
    backgroundColor: '#fff',
    borderRadius: 18,
    borderWidth: 1,
    borderColor: '#e8eefc',
    shadowColor: '#0f172a',
    shadowOffset: { width: 0, height: 10 },
    shadowOpacity: 0.08,
    shadowRadius: 20,
    elevation: 8,
  },
  card: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 14,
    paddingHorizontal: 12,
    borderWidth: 1,
    borderColor: '#e5e7eb',
    borderRadius: 10,
    marginBottom: 10,
    backgroundColor: '#fff',
  },
  serial: {
    fontSize: 15,
    fontWeight: '700',
    color: '#111827',
    width: 100,
  },
  content: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 10,
  },
  name: {
    flex: 1,
    fontSize: 15,
    color: '#111827',
    fontWeight: '500',
    marginRight: 10,
  },
  status: {
    fontSize: 14,
    fontWeight: '700',
  },

  // Modal Styles
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    backgroundColor: '#fff',
    borderRadius: 20,
    padding: 20,
    width: '90%',
    maxWidth: 500,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 20,
    textAlign: 'center',
    color: '#333',
  },
  modalFormGroup: {
    marginBottom: 15,
  },
  modalLabel: {
    fontSize: 14,
    fontWeight: '600',
    marginBottom: 5,
    color: '#333',
  },
  modalPickerWrapper: {
    borderWidth: 1,
    borderColor: '#000',
    borderRadius: 8,
    backgroundColor: '#fff',
    overflow: 'hidden',
  },
  modalPicker: {
    height: 50,
    width: '100%',
    color: '#333',
  },
  modalInputWrapper: {
    borderWidth: 1,
    borderColor: '#000',
    borderRadius: 8,
    backgroundColor: '#fff',
  },
  modalTextInput: {
    height: 50,
    paddingHorizontal: 12,
    fontSize: 16,
    color: '#333',
  },
  modalButtonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
    gap: 10,
  },
  modalButton: {
    flex: 1,
    paddingVertical: 12,
    borderRadius: 8,
    alignItems: 'center',
  },
  cancelButton: {
    backgroundColor: '#f5f5f5',
    borderWidth: 1,
    borderColor: '#ddd',
  },
  cancelButtonText: {
    color: '#666',
    fontSize: 16,
    fontWeight: '600',
  },
  updateButton: {
    backgroundColor: '#007bff',
  },
  updateButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '600',
  },
});
